import { render, staticRenderFns } from "./NewTicket.vue?vue&type=template&id=73f43ae4&scoped=true"
import script from "./NewTicket.vue?vue&type=script&lang=js"
export * from "./NewTicket.vue?vue&type=script&lang=js"
import style0 from "./NewTicket.vue?vue&type=style&index=0&id=73f43ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f43ae4",
  null
  
)

export default component.exports